module.exports = __webpack_public_path__ + "img/sablier.5528bbe3.svg";